import React, { FC } from 'react';
import { ProjectResponsibleFormProps } from './ProjectResponsibleFormProps';
import ResponsibleField from './ResponsibleField';
import useTranslation from '../../../hooks/useTranslation';

const ProjectResponsibleForm: FC<ProjectResponsibleFormProps> = ({
  fields,
  usersList,
}) => {
  const t = useTranslation();
  return (
    <>
      {fields.map((field) => (
        <ResponsibleField
          field={field.field}
          label={t(field.label)}
          usersList={usersList}
        />
      ))}
    </>
  );
};

export default ProjectResponsibleForm;
